import React from "react";
import { X, Search } from "lucide-react";
import Button from "../../Button";

interface ModalActionsProps {
  hasFilters: boolean;
  onSearch: () => void;
  onClear: () => void;
}

const ModalActions: React.FC<ModalActionsProps> = ({
  hasFilters,
  onSearch,
  onClear,
}) => {
  return (
    <div className="flex justify-end gap-3 border-t pt-4">
      <Button
        text="Limpar"
        icon={<X size={16} />}
        onClick={onClear}
        disabled={!hasFilters}
        className={`flex items-center gap-2 rounded-md px-6 py-2 transition-colors ${
          hasFilters
            ? "bg-neutral-200 text-neutral-700 hover:bg-neutral-300"
            : "cursor-not-allowed bg-neutral-100 text-neutral-400"
        }`}
      />
      <Button
        text="Buscar"
        icon={<Search size={16} />}
        onClick={onSearch}
        className="flex items-center gap-2 rounded-md bg-primary px-6 py-2 text-white transition-colors hover:bg-primary-dark"
      />
    </div>
  );
};

export default ModalActions;
